import React, { Fragment, useState, useMemo } from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2";

import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_GRADE, API_ENROLL, API_USER } from "../../../redux/apiRoutes";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";
import { v4 as uuidv4 } from 'uuid';
import FilterComponent from "../../common/filter";
import { encodeURI } from "js-base64";

function Enrolls(props) {
  const user = useSelector((content) => content.User);
  const navigate = useNavigate();

  const [modalNew, setModalNew] = useState(false);
  const toggleNew = () => { setModalNew(!modalNew); reset(); setEnrollTotalPayed(0); clearModal(); };

  const [modal, setModal] = useState(false);
  const toggle = () => { setModal(!modal); reset(); setEditingEnroll(false); setEnrollTotalPayed(0); clearModal(); };

  const clearModal = () => {
    setCurrentEnroll({});
    setcurrentschemePayment('');
    setcurrentgrade([]);
    setStudentSelected([]);
    setgradeSelected([]);
    setTypeEnroll('NEW');
    setChildsSelected([]);
  }

  const handleEditAction = (enroll) => {
    toggle();
    setEditingEnroll(true);
    setCurrentEnroll(enroll);

    setChildsSelected(enroll.childs);

    setTimeout(() => {
      setValue('enrollAmountPayed', enroll.enrollAmountPayed);
      setValue('eventsAmountPayed', enroll.eventsAmountPayed);
      setValue('materialsAmountPayed', enroll.materialsAmountPayed);
      setValue('sureAmountPayed', enroll.sureAmountPayed);
      setEnrollTotalPayed(enroll.payed);
    }, 500)
  }

  const [enrollTotalPayed, setEnrollTotalPayed] = useState(0);
  const calculatePayed = () => {
    let en = getValues('enrollAmountPayed');
    let ev = getValues('eventsAmountPayed');
    let mt = getValues('materialsAmountPayed');
    let sr = getValues('sureAmountPayed');

    setEnrollTotalPayed(Number(en) + Number(mt) + Number(sr) + Number(ev));
  }

  const [currentEnroll, setCurrentEnroll] = useState({});

  const handleDeleteAction = (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la inscripción del ciclo ${data.cicle} por $${data.total} para ${data.names} ${data.second_names}. ¡Está acción es irreversible!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await axios.delete(`${API_ENROLL}/${data.uuid}`).then(response => {
          getEnrollList();
          SweetAlert.fire("¡Listo!", "Inscripción eliminada", "success");
        }).catch(error => {
          setTimeout(() => {
            toast.error(
              "Error al eliminar la Inscripción: " + error
            );
          }, 200);
        });
      }
    });
  }

  const [studentSelected, setStudentSelected] = useState([]);
  const [dataStudents, setdataStudents] = useState([]);
  const getStudentsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&role=STUDENT`).then(response => {
      if (response.data.docs.length > 0) {
        const students = []
        response.data.docs.map(student => {
          const addStudent = {
            uuid: student.uuid,
            name: student.names,
            second_names: student.second_names,
            discount: student.discount,
            schemePayment: student.schemePayment,
            grade: student.grade,
          }
          students.push(addStudent);
        });
        setdataStudents(students);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const [currentgrade, setcurrentgrade] = useState('');
  const [currentschemePayment, setcurrentschemePayment] = useState('');

  const handleSelectStudent = async (e) => {
    setStudentSelected(e);

    e.map(student => {
      setValue('names', student.name);
      setValue('second_names', student.second_names);
    });
  }

  const estado = (status) => {
    switch (status) {
      case 'PAGADO':
        return <div><span className="badge badge-success">PAGADO</span> <br /></div>;
      case 'PENDIENTE':
        return <div><span className="badge badge-secondary">PENDIENTE</span> <br /></div>;
      case 'ABONANDO':
        return <div><span className="badge badge-primary">ABONANDO</span> <br /></div>;
    }
  }

  const columns = [
    {
      name: "Ciclo",
      selector: (row) => <b>{row.cicle}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Alumno(a)",
      selector: (row) => <b>{row.names} {row.second_names}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Grado",
      selector: (row) => row.grade.length > 0 && row.grade !== undefined && row.grade !== null ? row.grade[0].name : '',
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Estado",
      selector: (row) => estado(row.status),
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Adeudo",
      selector: (row) => '$' + row.debit,
      sortable: true,
      center: true,
    },
    {
      name: "Pagado",
      selector: (row) => '$' + row.payed,
      sortable: true,
      center: true,
    },
    {
      name: "Total",
      selector: (row) => <b>${row.total}</b>,
      sortable: true,
      center: true,
    },
    {
      name: "Acciones",
      selector: (row) => <div style={{ padding: 5 }}>
        {editPermissions ?
          <>
            <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleEditAction(row) }}><i className="fa fa-pencil"></i></Button>
            <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleDeleteAction(row) }}><i className="fa fa-trash"></i></Button>
          </>
          :
          <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleEditAction(row) }}><i className="fa fa-search"></i></Button>
        }
      </div>,
      width: '210px'
    },
  ];

  const [childsSelected, setChildsSelected] = useState([]);
  const [dataChilds, setdataChilds] = useState([]);
  const getChildsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&uuid=${user.uuid}`).then(response => {
      if (response.data.docs.length > 0) {
        if (response.data.docs[0].childs) {
          const childs = []
          response.data.docs[0].childs.map(child => {
            const addChild = {
              uuid: child.uuid,
              name: child.name,
              grade: child.grade,
            }
            childs.push(addChild);
          });
          setdataChilds(childs);
          getEnrollList(childs);
        }
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const getFullChildsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&role=STUDENT`).then(response => {
      if (response.data.docs.length > 0) {
        const childs = []
        response.data.docs.map(child => {
          const addchild = {
            uuid: child.uuid,
            name: child.names + ' ' + child.second_names,
            grade: child.grade,
          }
          childs.push(addchild);
        });
        setdataChilds(childs);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Alumnos: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const [dataInvoice, setDataInvoice] = useState([]);
  const [getInvoice, setGetInvoice] = useState(false);
  const [editPermissions, setEditPermissions] = useState(false);
  const getEnrollList = async (childs) => {
    setGetInvoice(true);

    let queryRule = '';
    if (user.role === 'TUTOR' && childs !== undefined) {
      let uuids = '';
      childs.map(child => {
        uuids = uuids + child.uuid + ',';
      });
      queryRule = `studentUuid=${uuids}`;
    }

    if (user.role === 'ADMIN' || user.role === 'SISTEMAS' || user.role === "DIRECTOR") {
      setEditPermissions(true);
    }

    await axios.get(`${API_ENROLL}?${queryRule}`).then(response => {
      if (response.data.docs.length > 0) {
        setDataInvoice(response.data.docs);
      } else {
        setDataInvoice([]);
      }
      setGetInvoice(false);
    }).catch(e => {
      setGetInvoice(false);
      toast.error("No se pudo obtener el listado de Alumnos: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const [creatingEnroll, setcreatingEnroll] = useState(false);
  const createEnroll = async (data) => {
    setcreatingEnroll(true);

    if (typeEnroll === 'REFRESH') {
      if (studentSelected.length <= 0) {
        toast.error("Asigna un alumno(a)", { position: 'bottom-right', style: { color: 'white' } });
        setcreatingEnroll(false);
        return;
      }
    }

    if (gradeSelected.length <= 0) {
      toast.error("Asigna un grado para el Alumno(a)", { position: 'bottom-right', style: { color: 'white' } });
      setcreatingEnroll(false);
      return;
    }

    data.cicle = '2026-2027';
    data.uuid = uuidv4();
    data.studentUuid = studentSelected.length > 0 ? studentSelected[0].uuid : '';
    data.grade = gradeSelected;
    data.type = typeEnroll;
    data.status = 'PENDIENTE';

    await axios.post(`${API_ENROLL}`, data).then(response => {
      getEnrollList();
      toggleNew();
      setcreatingEnroll(false);
      SweetAlert.fire("¡Listo!", "Inscripción registrada", "success");
    }).catch(error => {
      console.log(error)
      setTimeout(() => {
        toast.error(
          "Error al crear el documento de Inscripciones: " + error.response.data.message, { style: { color: 'white' } }
        );
      }, 200);
      setcreatingEnroll(false);
    });
  }

  const [isEditingEnroll, setEditingEnroll] = useState(false);
  const [patchingEnroll, setPatchingEnroll] = useState(false);
  const patchEnroll = async () => {
    setPatchingEnroll(true);

    let en = getValues('enrollAmountPayed');
    let ev = getValues('eventsAmountPayed');
    let mt = getValues('materialsAmountPayed');
    let sr = getValues('sureAmountPayed');

    let data = {
      enrollAmountPayed: en,
      eventsAmountPayed: ev,
      materialsAmountPayed: mt,
      sureAmountPayed: sr,
      total: currentEnroll.total,
    }

    if (currentEnroll.type === "NEW") {
      if (childsSelected && childsSelected.length > 0) { data.childs = childsSelected } else { user.childs = [] }
    } else {
      data.childs = null;
    }

    await axios.patch(`${API_ENROLL}/${currentEnroll.uuid}`, data).then(response => {
      getEnrollList();
      toggle();
      setPatchingEnroll(false);
      SweetAlert.fire("¡Listo!", "Inscripción actualizada", "success");
    }).catch(error => {
      setTimeout(() => {
        toast.error(
          "Error al actualizar: " + error.response.data.message, { style: { color: 'white' } }
        );
      }, 200);
      setPatchingEnroll(false);
    });
  }

  const [gradeSelected, setgradeSelected] = useState([]);
  const [dataGrades, setdataGrades] = useState([]);
  const getGradesList = async () => {
    await axios.get(`${API_GRADE}?status=ACTIVE`).then(response => {
      if (response.data.docs.length > 0) {
        const grades = []
        response.data.docs.map(grade => {
          const addGrade = {
            uuid: grade.uuid,
            name: grade.name + ' - ' + grade.level
          }
          grades.push(addGrade);
        });
        setdataGrades(grades);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Grados escolares: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  useEffect(() => {
    if (user.role === 'TUTOR') {
      getStudentsList();
      getGradesList();
      getChildsList();
    } else {
      getFullChildsList();
      getEnrollList();
      getStudentsList();
      getGradesList();
    }
    if (
      user.role !== 'ADMIN'
      && user.role !== "SISTEMAS"
      && user.role !== "DIRECTOR"
      && user.role !== "SUBDIRECTOR"
      && user.role !== "TUTOR"
    ) {
      navigate('/inicio');
    }
  }, [navigate]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(
    false
  );

  const filteredItems = dataInvoice.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const [typeEnroll, setTypeEnroll] = useState('NEW');
  const handleSetTypeEnroll = (type) => {
    setTypeEnroll(type);

    setValue('names', '');
    setValue('second_names', '');
  }

  return (
    <Fragment>
      <Breadcrumb parent="Finanzas" title="Inscripciones" />
      <Container fluid={true}>
        {editPermissions ?
          <Row>
            <Col sm="12" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20, paddingRight: 30 }}>
              <Button color="primary" onClick={toggleNew}>Crear Nueva</Button>
            </Col>
          </Row> : null}
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <DataTable
                  columns={columns}
                  striped={true}
                  center={true}
                  data={filteredItems}
                  pagination
                  subHeader
                  subHeaderComponent={subHeaderComponent}
                  noDataComponent={<b style={{ padding: 10 }}>No hay Inscripciones registradas</b>}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Inscripción
          <button className="btn-close invisible" type="button">
            <span aria-hidden="true" className="visible" onClick={toggle}></span>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="container">
            <Row className="g-3">
              <Col md="12">
                <Label className="form-label font-weight-bold">
                  Ciclo: {currentEnroll.cicle}
                </Label>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="12">
                <Label className="form-label font-weight-bold">
                  Tipo: {currentEnroll.type === 'NEW' ? 'NUEVO' : 'RE-INSCRIPCIÓN'}
                </Label>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="12">
                <Label className="form-label font-weight-bold">
                  Nombres Alumno(a): {currentEnroll.names}
                </Label>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="12">
                <Label className="form-label font-weight-bold">
                  Apellido(s) Alumno(a): {currentEnroll.second_names}
                </Label>
              </Col>
            </Row>
            <Row className="g-3">
              <Col md="12">
                <Label className="form-label font-weight-bold">
                  Grado al que va: {currentEnroll.grade !== undefined && currentEnroll.grade !== null && currentEnroll.grade.length > 0 ? currentEnroll.grade[0].name : null}
                </Label>
              </Col>
            </Row>
            <Row className="g-3">
              {currentEnroll.type === "NEW" ?
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Vincular alumno creado
                  </Label>
                  <Typeahead
                    id="gradeFinder"
                    clearButton
                    defaultSelected={childsSelected}
                    labelKey="name"
                    multiple
                    options={dataChilds}
                    placeholder="Buscar..."
                    onChange={(e) => { setChildsSelected(e) }}
                  />
                </Col> : null}
            </Row>
            <Row className="g-3 dflex mb-2 mt-2">
              <Col md="12">
                <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                  <span style={{ width: '100%', textAlign: 'end' }}>Pagado</span> &nbsp;
                </h5>
                <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                  <span style={{ width: '100%', textAlign: 'end' }}>Inscripción: $3,000</span> &nbsp;
                  {editPermissions ?
                    <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="enrollAmountPayed" {...register("enrollAmountPayed", { required: true })} /> : <span className="p-2 rounded" style={{ background: '#d4d4d4' }}>${currentEnroll.enrollAmountPayed}</span>}
                </h5>
                <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                  <span style={{ width: '100%', textAlign: 'end' }}>Eventos: $1,350</span> &nbsp;
                  {editPermissions ?
                    <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="eventsAmountPayed" {...register("eventsAmountPayed", { required: true })} /> : <span className="p-2 rounded" style={{ background: '#d4d4d4' }}>${currentEnroll.eventsAmountPayed}</span>}
                </h5>
                <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                  <span style={{ width: '100%', textAlign: 'end' }}>Material: $2,300</span> &nbsp;
                  {editPermissions ?
                    <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="materialsAmountPayed" {...register("materialsAmountPayed", { required: true })} /> : <span className="p-2 rounded" style={{ background: '#d4d4d4' }}>${currentEnroll.materialsAmountPayed}</span>}
                </h5>
                <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                  <span style={{ width: '100%', textAlign: 'end' }}>Seguro: $450</span>&nbsp;
                  {editPermissions ?
                    <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="sureAmountPayed" {...register("sureAmountPayed", { required: true })} /> : <span className="p-2 rounded" style={{ background: '#d4d4d4' }}>${currentEnroll.sureAmountPayed}</span>}
                </h5>
              </Col>
            </Row>
            <Row className="g-3 dflex mb-2">
              <Col md="12" style={{ textAlign: 'end' }}>
                <h4 className="form-label font-weight-bold">
                  Total Pagado: &nbsp;
                  <b>${enrollTotalPayed}</b>
                </h4>
                <h4 className="form-label font-weight-bold">
                  Total Inscripción: &nbsp;
                  <b>${currentEnroll.total}</b>
                </h4>
              </Col>
            </Row>
            {editPermissions ?
              <Row style={{ display: 'flex', justifyContent: 'end', paddingTop: 20 }}>
                <Button onClick={patchEnroll} disabled={patchingEnroll} className="btn btn-primary" style={{ width: 150 }} color="primary">{"Guardar"}</Button>
              </Row> : null}
          </div>
        </ModalBody>
      </Modal>

      {editPermissions ?
        <Modal isOpen={modalNew} toggle={toggleNew}>
          <ModalHeader toggle={toggleNew}>Nueva Inscripción
            <button className="btn-close invisible" type="button">
              <span aria-hidden="true" className="visible" onClick={toggleNew}></span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div className="container">
              <Form className="needs-validation" noValidate="" onSubmit={handleSubmit(createEnroll)} style={{ padding: 20 }}>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold" for="validcicle">
                      Ciclo:
                    </Label>
                    <input className="form-control" value="2026-2027" disabled id="validcicle" type="text" placeholder="Ciclo Escolar" name="cicle" {...register("cicle")} />
                    <span>{errors.cicle && "Ciclo Escolar Requerido"}</span>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Tipo:
                    </Label>
                    <br />
                    <select name="schemePayment" className="form-control mb-1" onChange={(e) => handleSetTypeEnroll(e.target.value)}>
                      <option value="NEW">Nuevo Ingreso</option>
                      <option value="REFRESH">Re-Inscripción</option>
                    </select>
                  </Col>
                </Row>
                {typeEnroll === 'NEW' ?
                  <>
                    <Row className="g-3 dflex mb-3">
                      <Col md="12">
                        <Label className="form-label font-weight-bold" for="validstudentName">
                          Nombres Alumno(a):
                        </Label>
                        <input className="form-control" id="validstudentName" type="text" placeholder="Nombres" name="names" {...register("names", { required: true })} />
                        <span>{errors.names && "Nombres Requerido"}</span>
                      </Col>
                    </Row>
                    <Row className="g-3 dflex mb-3">
                      <Col md="12">
                        <Label className="form-label font-weight-bold" for="validstudentLasts">
                          Apellido(s) Alumno(a):
                        </Label>
                        <input className="form-control" id="validstudentLasts" type="text" placeholder="Apellidos" name="second_names" {...register("second_names", { required: true })} />
                        <span>{errors.second_names && "Apellidos Requerido"}</span>
                      </Col>
                    </Row>
                  </>
                  :
                  <>
                    <Row className="g-3 dflex mb-3">
                      <Col md="12">
                        <Label className="form-label font-weight-bold">
                          Alumno(a):
                        </Label>
                        <Typeahead
                          id="gradeFinder"
                          clearButton
                          defaultSelected={studentSelected}
                          labelKey="name"
                          options={dataStudents}
                          placeholder="Buscar Alumno(a)..."
                          onChange={(e) => { handleSelectStudent(e) }}
                        />
                      </Col>
                    </Row>
                  </>
                }
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Grado al que va:
                    </Label>
                    <br />
                    <Typeahead
                      id="gradeFinder"
                      clearButton
                      defaultSelected={gradeSelected}
                      labelKey="name"
                      options={dataGrades}
                      placeholder="Elegir Grado..."
                      onChange={(e) => { setgradeSelected(e) }}
                    />
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2 mt-2">
                  <Col md="12">
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                      <span style={{ width: '100%', textAlign: 'end' }}>Inscripción: $3,000</span> &nbsp;
                      <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="enrollAmountPayed" {...register("enrollAmountPayed", { required: true })} />
                    </h5>
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                      <span style={{ width: '100%', textAlign: 'end' }}>Eventos: $1,350</span> &nbsp;
                      <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="eventsAmountPayed" {...register("eventsAmountPayed", { required: true })} />
                    </h5>
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                      <span style={{ width: '100%', textAlign: 'end' }}>Material: $2,300</span> &nbsp;
                      <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="materialsAmountPayed" {...register("materialsAmountPayed", { required: true })} />
                    </h5>
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'end' }}>
                      <span style={{ width: '100%', textAlign: 'end' }}>Seguro: $450</span>&nbsp;
                      <input onKeyUp={() => calculatePayed()} className="form-control" type="number" style={{ width: 150 }} placeholder="Abono" name="sureAmountPayed" {...register("sureAmountPayed", { required: true })} />
                    </h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2">
                  <Col md="12" style={{ textAlign: 'end' }}>
                    <h4 className="form-label font-weight-bold">
                      Pagado: &nbsp;
                      <b>${enrollTotalPayed}</b>
                    </h4>
                    <h4 className="form-label font-weight-bold">
                      Total: &nbsp;
                      <b>$7,100</b>
                    </h4>
                  </Col>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'end', paddingTop: 20 }}>
                  <Button disabled={creatingEnroll} className="btn btn-primary" style={{ width: 150 }} color="primary">{"Crear"}</Button>
                </Row>
              </Form>
            </div>
          </ModalBody>
        </Modal> : null}

    </Fragment>
  );
}

export default Enrolls;
